import React from 'react'

const Manual_filtrar_clientes_predefinido = () => {
  return (
    <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-10">
      <div className="mt-16">
        <h2 className="font-bold xl-text-[40px] lg:text-4xl text-4xl text-[#002D33] mb-5">
          ¿Cómo filtrar clientes de manera predefinida?
        </h2>
        <p className="text-lg text-gray-700 mb-6">
          Aprende a usar los filtros predefinidos para segmentar clientes de forma automática en Clau.io.
        </p>
        <iframe
          src="https://scribehow.com/embed/Como_filtrar_clientes_de_manera_predefinida__KmN6VVaPR8mo0ZfQpR7oqw?as=scrollable"
          className="scribe-iframe-general-92"
          width="100%"
          height="4100"
          allowFullScreen
          style={{ border: 0, minHeight: '640px' }}
        ></iframe>
      </div>
    </div>
  )
}

export default Manual_filtrar_clientes_predefinido
